// extracted by mini-css-extract-plugin
export var base = "card-module--base--FZUfS";
export var cardtext = "card-module--cardtext--vEfe-";
export var link = "card-module--link--fE-kP";